import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  GridApiUrl = "/api/AlarmLog/GetAlarmlaststatuscount";
  getMenuUrl = "/api/Generic/GetFeatureMaster";
  getCmdAuditLogUrl = "/api/Audit/AuditLog";
  forgotPass = "/api/UpdateAndForgotPwd/ForgotPassword";
  changePasswordUrl = "/api/UpdateAndForgotPwd/UpdatePassword";
  jwtloginUrl = "/api/Login/LoginAuth";
  azureLoginUrl = "/api/Login/AzureLoginAuth";
  logoutUrl = "/api/Login/LogoutRequest";
  siteListingApi = "/api/SiteListing/GetSiteListingResponse";
  siteListingExport = "/api/SiteListing/GetSiteListingExport";
  AlarmLogExport = "/api/AlarmLog/GetAlarmLogExport";
  alarmlastStatusUrl = "/api/AlarmLog/GetAlarmLogData";
  alarmRecordsUrl = "/api/AlarmLog/GetAlarmLogRecords";
  alarmsSiteDetailsUrl = "/api/AlarmLog/GetAlarms";
  alarmCountLastStatus = "/api/AlarmLog/GetAlarmlaststatuscount";
  alarmCountRecords = "/api/AlarmLog/GetAlarmrecordsstatuscount";
  getOverAllOpentime = "/api/AlarmLog/GetRegionorCriticalstatuscount";
  getalarmGenericData = "/api/AlarmLog/Getgenericdata";
  GetAlarmdata = "/api/AlarmLog/GetAlarmdata";
  GetHighlevelsummarydata = "/api/AlarmLog/GetHighlevelsummarydata";
  saveSettingsUrl = "/api/SaveSettings/SaveSettingsRequest";
  getEquipmentListUrl = "/api/Reports/Getequipments";
  getEquipmentConfigUrl = "/api/Reports/GetEquipmentParameters";
  saveReportSetting = "/api/Reports/CustomReports/SaveReportSettings";
  getSavedReport = "/api/Reports/GetSavedreports";
  getSavedReports = "/api/GetSavedReport/GetSavedreports";
  getReportdata = "/api/Reports/GetReport";
  getReportdatas = "/api/Report/GenerateReport";
  getSavedReportData = "/api/Reports/Reports/EditSavedReportSettings";
  exportReportsUrl = "/api/Reports/ExportReport";
  exportedReportsUrl = "/api/Reports/ExportedFiles";
  downloadReports = "/api/Reports/Download";
  downloadReportsfromApi = "/api/Reports/APIExport";
  commandsUrl = "/api/SaveSettings/CommandRequest";
  createTTUrl = "/api/MuleSoft/CreateCase";
  //old Schedule
  // schreportUrl = "/api/reports/ScheduleReport";
  // getSchReports = "/api/reports/GetScheduleReport";
  // getSchEmaillist = "/api/Reports/GetUserEmailIds";
  // getSchDelete = "/api/reports/DeactiveScheduleReport/";
  // getSchDelete = "/api/reports/DeactiveScheduleReport";

  //new Schedule
  schReport = "/api/ReportSchedular/ScheduleReport";
  getScheduleReport = "/api/ReportSchedular/GetScheduleReport";
  getUserName = "/api/ReportSchedular/GetUserName";

  userSettingsUrl = "/api/UserSettings/GetUserSettings";
  saveUserSettingsUrl = "/api/SaveSettings/UserSettingsRequest";

  airconCommandsUrl = "/api/SaveSettings/AirConDetails";
  //EMS
  paymentIdUrl = "/api/Razorpay/PaymentCaptureRequest";
  createOrder = "/api/Razorpay/create-order";

  // ***********************************************************************************************
  // Login
  loginUrl = "Auth/Authenticate";
  imageLogoURL = "Auth/GetAccountData";
  loginTokenUrl = "Auth/AzureAuthenticated";
  getCustomerIDUrl = "EquipmentsCommand/GetCustomerID";
  //Forget Password
  forgetPassUrl = "Auth/ForgotPassword";
  // userNameUrl = "Auth/ConfirmUserName";
  // changePasswordUrl = "Auth/ChangePasswordWithOutLogin";

  // * default layout
  sublitChangePasswordUrl = "Auth/ChangePassword";
  // getMenuUrl = "Auth/GetMenuData";
  // * Site Listing
  exportpdf = "SiteListing/ExportGetSiteListingData";
  dynamicaData = "Usersettings/DisplayUserSettings";
  searchZoneUrl = "Zone/GetZoneDetails";
  searchClusterUrl = "Cluster/GetClusterList";
  searchRegionUrl = "Region/GetRegionList";
  siteListingSummaryUrl = "SiteListing/GetSiteStatusCount";
  siteListingUrl = "SiteListing/GetSiteListingData";
  siteListingHeader = "SiteListing/GetSiteListingHeaders";
  searchSiteClassUrl = "Site/GetSiteClass";
  searchCoolClassUrl = "Site/GetCoolingClass";
  searchEnergyClassUrl = "Site/GetEnergyClass";
  searchSiteUrl = "Site/GetSiteList";
  liAlarmsList = "SiteListing/GetSiteListingLiAlarms/";
  siteAccessLink = "SiteListing/GetSiteAccessStatus/";

  //Site Monitoring
  siteMonitoringHeaders = "SiteListing/GetSiteMonitoringHeaders";
  siteMonitoringData = "SiteMonitoring/GetSiteMonitoringData";
  //Site Details
  tabListSummary1 = "SiteDetailed/GetEquipmentsList/";
  siteEquipmentDataUrl = "SiteDetailed/GetSiteEquipmentData/";
  siteInfoUrl = "SiteDetailed/GetSiteLastStatusData/";
  awlSensor = "SiteDetailed/GetAwlSensorData/";
  neutralSensor = "SiteDetailed/GetNeutralGroundSensorData/";
  powerSrcChartUrl = "SiteChartData/GetPowerSourceData";
  noOfCamerasURL = "Camera/GetCameraConfig";
  allSensorTempUrl = "SiteChartData/GetSensorDetails/";
  getLiveStreamURL = "Camera/GetLiveStreamURL";
  pollCommandUrl = "SiteDetailed/SendPolOutgoingCommand";
  getImgPathURL = "Camera/GetImagePath";
  dcPowerDetails = "SiteDetailed/GetDCData/";
  siteListDropDownUrl = "Site/GetSiteList/";
  siteAlarmDataUrl = "Alarms/GetSiteAlarmStatus/";
  rybPowerParameterUrl = "SiteDetailed/GetPowerParameters/";
  getPowerSourceUrl = "SiteDetailed/GetSitePowerSource/";
  dcTenantUrl = "SiteDetailed/GetDCTenantData/";
  acTenantUrl = "SiteDetailed/GetACTenantData/";
  fuelFillDetailsUrl = "SiteDetailed/GetSiteFuelFillDetails/";
  allUserChartListUrl = "SiteChartData/GetUserChartList";
  dcTenSummary2 = "SiteDetailed/GetDCTenantData/";
  acTenSummary1 = "SiteDetailed/GetACTenantData/";
  powerPlantSummary = "SiteDetailed/GetPowerPlantData/";
  genSummary = "SiteDetailed/GetSiteGeneratorLastStatus/";
  rectSummary = "SiteDetailed/GetSiteRectifierLastStatus/";
  airSummary = "SiteDetailed/GetSiteAirconLastStatus/";
  avrDataUrl = "Reports/GetAVRController/";
  siteAccessDataurl = "SiteDetails/GetSiteAccessData/";
  acPowerUrl = "SiteChartData/GetACPowerData";
  fuelChartUrl = "SiteChartData/GetDGFuelLevel";
  sitePowerhistoryDataUrl = "SiteDetailed/GetSiteEnergyData/";
  getMessages = "SiteDetailed/GetBulletianMessage/";
  equipmentGenTabs = "Equipments/GetEquipments/";
  dgBatteryUrl = "";

  //Alarms
  alarmGridUrl = "Alarms/GetAlarmDetails";
  searchAlarmUrl = "Alarms/GetAlarmList";
  carddataUrl = "Alarms/GetAlarmCountDetails";
  ExportAlarm = "Alarms/AlarmLogExport";

  //Alarm History
  ttCreationUrl = "TroubleTicketLog/CorelateTT";

  //alarm Config
  useralarmConfigparams = "Alarms/GetUserConfigurableParameters";
  alarmUpdateuserConfig = "Alarms/UpdateUserConfiguredAlarm";
  alarmCreateUserConfig = "Alarms/CreateUserConfiguredAlarm";
  alarmGetPinsForUser = "Alarms/GetAvailablePinsforUser";
  alarmDeleteUserConfig = "Alarms/DeleteUserConfiguredAlarm";
  getCreatedAlarmPin = "Alarms/GetUserCreatedalarmPins";
  alarmUserConfigurable = "Alarms/GetUserConfigurableAlarm/";

  actionEscalateMailUrl = "Alarms/SendEmail";
  actionEscalateSMSUrl = "Alarms/SendSMS";
  actionClearUrl = "Alarms/ClearAlarm";
  fuelNotificationCloseUrl = "/api/SaveSettings/CloseAlarm";
  actionAckUrl = "Alarms/AcknowledgeAlarm";
  createTTfromFootprint = "Alarms/CreateTTFromFootPrint";
  troubleTicketDetails = "TroubleTicketLog/Details";

  getEquipmentParameters =
    "CustomReports/GetUserSavedReportsSelectedParametersWithSchedule";
  SaveUpdateUrl = "CustomReports/UpdateReportSettings";
  DeleteSaved = "CustomReports/DeleteSettings";
  getEmailUrl = "Reports/GetUserEmailIds";
  sendModeCmdURL = "EquipmentsCommand/SendModeCommand";
  AirconStartStopURL = "EquipmentsCommand/SendAirconStartStopCommand";
  generatorStartStopURL = "EquipmentsCommand/SendGenStartStopCommand";

  //Site List Actions
  siteListingPollCommandUrl = "SiteListing/SendPolOutgoingCommand";
  configuredAlarmsURL = "Alarms/GetSiteAlarmStatus/";

  //Analytical DrillDown
  analyticaldrilldown = "Reports/DrillDownAvailabilityReport";
  avialabilityreport = "Reports/AvailabilityReport";
  accuacydrilldown = "Reports/DrillDownAccuracyReport";
  equimentUrl = "Reports/GetEquipmentList/";

  //Analytical Report
  searchTenantUrl = "Reports/getTenantList";
  getControllerUrl = "Reports/GetControllers";
  getGeneratorUrl = "Generator/GetSiteBasedGenerators";
  getControllerUrl1 = "Generator/GetGeneratorBasedControllers";
  getAnalyticalReportSetting = "Reports/GetAnalyticalSettings";
  getAVRController = "Reports/GetAVRController";
  saveReportsformdataUrl = "Reports/SaveReportSettings";
  deleteSavedFiltersURL = "Reports/DeleteSettings/";
  getSavedReportsUrl = "Reports/GetReportSettings";
  sensorchart = "Reports/AnalyticalAvailabilityChart";
  getControllerSetting = "Reports/GetControllerSettings";
  saveScheduleReportUrl = "Reports/SaveScheduleReportSettings";
  getScheduleReportMaxAndTotalLimitUrl =
    "Reports/GeUserScheduledReportMaxAndTotalLimit";
  validateScheduleRepUrl = "Reports/ValidateScheduleReportSettings";
  analyticalviewReportUrl = "Reports/ViewScheduleReportSettings/4";
  subscribeScheduleRepUrl = "Reports/AddSubscriberToScheduleReportSettings/";
  viewSubscribeUrl = "Reports/ViewSubscribeScheduleReportSettings";
  DeleteScheduleRepUrl = "Reports/DeleteScheduleReportSettings/";
  EditScheduleRepUrl = "Reports/EditScheduleReportSettings/";
  UpdateScheduleRepUrl = "Reports/UpdateScheduleReportSettings";
  vendorapi = "Vendor/GetVendorList";
  searchfosUrl = "FOS/GetFOSList";
  reportsURL = "Reports/AnalyticalReports";
  weeklistapi = "Reports/WeeklyCalender/";

  //Graphical Dashboard
  getSiteLayoutLoadChart = "SiteChartData/GetSiteLayoutLoadChartData/";
  getSiteLayoutRunHoursData = "SiteChartData/GetSiteLayoutRunHrsData/";
  getSiteLayoutEnergyData = "SiteChartData/GetSiteLayoutEnergyData/";
  batteryVoltageData = "Battery/GetSiteLayoutBatteryDcVoltage/";
  solarPowerApi = "Solar/GetSolarParametersData/";
  acTenSummary = "SiteDetailed/GetACTenantData/";
  solarDataApi = "Solar/GetSiteLayoutSolarVIPData/";
  gridPowerurl = "SiteDetailed/GetPowerParameters/";
  siteLayoutMeterLastStatus = "SiteDetailed/GetSiteLayoutMeterLastStatus/";
  runHoursChartData = "SiteChartData/GetSiteLayoutRunHrsData/";
  tenantsData = "SiteDetailed/GetSiteTenantLastStatus/";
  gridDataChart = "SiteChartData/GetPowerParameters/";
  equipmentChartData = "SiteChartData/GetSensorData/";
  batteryChartData = "SiteChartData/GetBatteryParameters/";
  activePowerSource = "SiteDetailed/GetActivePowerSource/";
  energyAcTenantsApi =
    "EnergyDistributionChart/GetEnergyDistChartACTenantData/";
  energyDcTenantsApi =
    "EnergyDistributionChart/GetEnergyDistChartDCTenantData/";
  overallEnergyData = "SiteDetailed/GetSiteWiseFuelTankData/";

  //Camera Images
  getImageListURL = "Camera/GetImageList";
  downloadimage = "/api/CameraImage/CameraImageDownload";

  // Chart Sidebar - Energy reports
  getReportSetting = "Reports/GetSettings";
  energyViewReportUrl = "Reports/ViewScheduleReportSettings/1";
  criticalCount = "Alarms/GetSiteAlarmCount";
  ControllerReportsURL = "Reports/ControllerReports";
  SummaryReportsURL = "Reports/SummaryReports";
  DetailedReportsURL = "Reports/DetailedReports";

  // Controller Report
  GetControllerReport = "Reports/GetControllerReport";

  //Custom Report
  // getReportdata = "CustomReports/GetReportData";
  getSavedReportsEdit = "CustomReports/GetEditReportSettings";
  getCustomReportSetting = "CustomReports/GetReportSettings";
  getSaveReportSetting = "CustomReports/SaveReportSettings";
  ClustorZoneUrl = "CustomReports/GetFilterTypeOptions";
  AcmeterUrl = "CustomReports/GetCustomReportAcTenantDetails";
  DCmeterUrl = "CustomReports/GetCustomReportDcTenantDetails";
  powerPlantUrl = "CustomReports/PowerPlants";
  customReportUserFilter = "CustomReports/GetUserFilterTypes";
  url_shedule = "Reports/AddCustomScheduleReport";
  url_shedulecheck = "CustomReports/ValidateScheduleReport";
  getCustomReportPdf = "CustomReports/GetReportData";
  //Equipment Command
  getEquipmentCommandURL = "EquipmentsCommand/GetSitesList";
  equipmentEnableDisableBtn = "EquipmentsCommand/SendAutomationCommand";
  doorOpenCommandurl = "EquipmentsCommand/SendDoorOpenCommand";
  SendStartStopAll = "EquipmentsCommand/SendStartStopAllCommand";

  // Equipments
  // aircon
  airconStartOrStop = "Aircon/SendAirconStartStopCommand";
  airconSendCommand = "Aircon/SendAirconCommand";
  airconStatusDetails = "Aircon/GetAirconStatus/";
  airconAlarmDetails = "Aircon/GetAirconAlarms/";
  airconDetails1 = "Aircon/GetAirconDetails";
  airconShelterInfo = "Aircon/GetAirconShelterInfo";

  //avr
  getAVrDropdown = "AVR/GetAVRControllerList/";
  getAVRInputAlarm = "AVR/GetAVRInputAlarmData/";
  getAVRAlarmData = "AVR/getAVRAlarmData/";
  equipmentAVrDatas = "AVR/GetAVRControllerData/";

  //Battery
  getLIonBatteryInfo = "Battery/GetLithiumBatteryData/";
  getBatteryEnergy = "Battery/GetBatteryEnergy/";
  getLiBatteryTraps = "Battery/GetLiBatteryTraps/";
  getLiIonCellData = "Battery/GetLiBatteryData/";
  getLiIonBatteryParams = "Battery/GetLiBatteryParams/";
  getLiIonBatteryModules = "Battery/GetBatteryModules/";
  liIonBatteryInfoURL = "Battery/GetLithiumOverallData/";

  //vrla
  getVrlaAlarms = "Battery/GetVRLABatteryAlarms/";
  getvrlaCellData = "Battery/GetVRLABatteryData/";
  getVrlaBatteryModules = "Battery/GetVRLABatteryModules/";

  //Gen
  equipCmdMode = "Generator/SendGeneratorCommand";
  getGeneratedDataUrl = "Generator/GetGeneratorCommandDetails/";
  ProcessGCFCmndURL = "Generator/SendGCFCommand";
  equipmentGenOnOff = "Generator/SendGenStartStopCommand";
  AlarmresetApi = "Generator/SendAlarmResetCommand";
  equipmentGeneratorAll = "Generator/GetGeneratorControllerData/";
  equipmentGeneratorAlarm = "Generator/GetGeneratorAlarms/";
  // Rectifier
  equipmentGetPara = "Rectifier/GetModuleData/";
  equipmentRectiSendCommand = "Rectifier/SendRectifierCommand";
  equipmentRectiController = "Rectifier/GetControllerSettingsData/";
  equipmentRectiInfo = "Rectifier/GetRectifierControllerData/";
  equipmentRectifierAlarm1 = "Rectifier/GetRectifierAlarmData/";
  //Solar
  solarAPIUrl = "Solar/GetSolarAlarmData/";
  solarDataApiUrl = "Solar/GetSolarParametersData/";
  PVCellChart = "Solar/GetPVCellPowerChartData";
  EnergyChart = "Solar/GetGeneratedEnergyChartData";
  TempChart = "Solar/GetAmbientTempChartData";
  VIPData = "Solar/GetSolarVIPData/";

  //Get Controller Module
  equipmentGetModule = "Rectifier/GetModulesList/";

  //iSense Config
  iSenseGrid = "iSenseDashboard/GetConfiguredData/";

  //Modbus terminal
  siteList = "ModbusCommand/GetSiteList";
  GetEquipmentType = "ModbusCommand/GetEquipmentType";
  CommandType = "ModbusCommand/GetCommandType";
  CommandMode = "ModbusCommand/GetCommandMode/";
  CommandPort = "ModbusCommand/GetCommandPort/";
  SavemodbusTerminalUrl = "ModbusCommand/SendCommand";

  //Modbus terminal history
  SavemodbusTerminalHistoryUrl = "ModbusCommand/ModBusHistoryReport";

  //Outgoing command
  searchedsiteList = "OutgoingCommand/GetSearchedSiteList";
  getOutgoingCommandsURL = "OutgoingCommand/GetCommandsList";

  //report Dashboard
  dashBoardDetails1 = "AlarmDashboard/GetDashboardData";

  //Site Access History
  siteAccessURL = "SiteDetails/GetSiteAccessHistory/";

  //Maps
  getSiteOnMap = "SiteListing/GetSiteInfoOnMap";
  PowerSourceCount = "SiteListing/GetPowerSourceCount";

  //Summary Dashboard
  graphDataUrl = "HLSD/HLSDD";
  quickStatsUrl = "HLSD/HLGSDD";

  //User Settings
  alrmLogAccessModeUrl = "Usersettings/GetAlarmPageCols";
  alarmPinModeUrl = "Usersettings/GetAlarmPins";
  displayAccessMode = "Usersettings/GetSiteListingCols";
  landingPageUrl = "Auth/GetMenuData";
  SaveUserSettingUrl = "Usersettings/UpdateUserSettings";

  //TT Log
  getSites = "/api/TTApi/GetSites";
  getAccount = "/api/TTApi/GetAccount";
  getSeverity = "/api/TTApi/GetSeverity";
  getCompany = "/api/TTApi/GetCompany";
  getTTStatus = "/api/TTApi/GetTTStatus";
  getDepartments = "/api/TTApi/GetDepartments";
  setTTLog = "/api/TTApi/SetTroubleTicketLog";
  getTTLog = "/api/TTApi/GetTTData";
  setAssignTicket = "/api/TTApi/SetTTAssignEngineer";
  setCloseTicket = "/api/TTApi/SetTTStatusRepo";
  getUsers = "/api/Users/GetUsers";
  getCountry = "/api/Country/GetCountry";
  getZone = "/api/Zone/GetZone";
  getRegion = "/api/Circle/GetCircle";
  getCluster = "/api/Cluster/GetCluster";
  getSiteInfo = "/api/SiteMaster/GetSiteInfo";
  getApplication = "/api/TTApi/GetApplication";

  // New Reports API 3.0
  getEquipments = "/api/GetSavedReport/GetSavedReports";
  getEquipColumns = "/api/Override/ColumnConfiguration";
  getUserType = "/api/Users/GetUsersType";
  saveCustomReports = "/api/CustomReport/SaveCustomReport";
  publishReport = "/api/CustomReport/PublishCustomReport";
  getTenant = "/api/Tenant/GetTenant";
  constructor() {}
}
